<ng-container *ngIf="companyInfo">
    <li class="fvms-tree-item" [class.active]="isSelectedCompany() === true">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-link text-secondary pr-1" (click)="changeIsOpen()">
                <i class="bi"
                    [class.bi-chevron-right]="isOpenChild === false"
                    [class.bi-chevron-down]="isOpenChild === true"></i>
            </button>
            <div class="fvms-tree-label text-nowrap flex-grow-1" (click)="clickSelectCompany()">
                {{companyInfo.companyNm}}
            </div>
            <div class="d-flex">
                <button type="button" class="btn btn-outline-light text-secondary border-0"
                    (click)="clickAddCompanyChild(companyInfo)">
                    <i class="bi bi-plus"></i>
                </button>
                <button type="button" class="btn btn-outline-light text-secondary border-0"
                    (click)="clickRemoveCompany(companyInfo)"
                    [disabled]="companyInfo.companyId === 1 || companyInfo.companyId === '1'">
                    <i class="bi bi-dash"></i>
                </button>
            </div>
        </div>
        <ng-container *ngIf="listCompanyInfo">
            <ul class="fvms-tree-list">
                <ng-container *ngFor="let companyInfoChild of listCompanyInfo"
                    [class.d-none]="isOpenChild === false"
                    [class.d-block]="isOpenChild === true">
                    <dtg-manage-company-tree
                        [nodeInfo]="{companyInfo:companyInfoChild}"
                        (openParentOut)="changeOpenParentOut($event)"></dtg-manage-company-tree>
                </ng-container>
            </ul>
        </ng-container>
    </li>

    <!-- <div class="d-flex justify-content-between align-items-center"
        [class.bg-warning]="isSelectedCompany() === true">
        <div>
            <button type="button"
                class="btn btn-link text-secondary pr-0"
                (click)="changeIsOpen()">
                <i class="mdi"
                    [class.mdi-chevron-right]="isOpenChild === false"
                    [class.mdi-chevron-down]="isOpenChild === true"></i>
            </button>
        </div>
        <div class="flex-grow-1">
            <button type="button" class="btn btn-link btn-block text-decoration-none text-left text-body text-nowrap"
                (click)="clickSelectCompany()">
                {{companyInfo.companyNm}}
            </button>
        </div>
        <div class="d-flex">
            <button type="button" class="btn btn-link text-left text-secondary"
                (click)="clickAddCompanyChild(companyInfo)">
                <i class="fas fa-plus"></i>
            </button>
            <button type="button" class="btn btn-link text-left text-secondary"
                (click)="clickRemoveCompany(companyInfo)"
                [disabled]="companyInfo.companyId === 1 || companyInfo.companyId === '1'">
                <i class="fas fa-minus"></i>
            </button>
        </div>
    </div>
    <ng-container *ngIf="listCompanyInfo">
        <div *ngFor="let companyInfoChild of listCompanyInfo"
            class="ml-3"
            [class.d-none]="isOpenChild === false"
            [class.d-block]="isOpenChild === true">
            <dtg-manage-company-tree
                [nodeInfo]="{companyInfo:companyInfoChild}"
                (openParentOut)="changeOpenParentOut($event)"></dtg-manage-company-tree>
        </div>
    </ng-container> -->
</ng-container>
